var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7321_9330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7321_9330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00026 7.66797V9.16797C8.00026 9.30964 8.04821 9.42836 8.14409 9.52414C8.23998 9.62002 8.35876 9.66797 8.50043 9.66797C8.64221 9.66797 8.76093 9.62002 8.8566 9.52414C8.95237 9.42836 9.00026 9.30964 9.00026 9.16797V7.66797H10.5003C10.6419 7.66797 10.7607 7.62002 10.8564 7.52414C10.9523 7.42825 11.0003 7.30947 11.0003 7.1678C11.0003 7.02602 10.9523 6.9073 10.8564 6.81164C10.7607 6.71586 10.6419 6.66797 10.5003 6.66797H9.00026V5.16797C9.00026 5.0263 8.95232 4.90758 8.85643 4.8118C8.76054 4.71591 8.64176 4.66797 8.50009 4.66797C8.35832 4.66797 8.23959 4.71591 8.14393 4.8118C8.04815 4.90758 8.00026 5.0263 8.00026 5.16797V6.66797H6.50026C6.3586 6.66797 6.23987 6.71591 6.1441 6.8118C6.04821 6.90769 6.00026 7.02647 6.00026 7.16814C6.00026 7.30991 6.04821 7.42864 6.1441 7.5243C6.23987 7.62008 6.3586 7.66797 6.50026 7.66797H8.00026ZM8.50026 13.5103C9.80448 12.3427 10.8025 11.2229 11.4944 10.1506C12.1863 9.07841 12.5323 8.1393 12.5323 7.3333C12.5323 6.11797 12.1462 5.11886 11.3739 4.33597C10.6017 3.55308 9.64382 3.16164 8.50026 3.16164C7.35671 3.16164 6.39882 3.55308 5.6266 4.33597C4.85437 5.11886 4.46826 6.11797 4.46826 7.3333C4.46826 8.1393 4.81421 9.07841 5.5061 10.1506C6.19798 11.2229 7.19604 12.3427 8.50026 13.5103ZM8.50026 14.4615C8.37037 14.4615 8.24048 14.4391 8.11059 14.3943C7.9806 14.3494 7.86304 14.28 7.75793 14.186C7.15971 13.6346 6.59987 13.0669 6.07843 12.4826C5.5571 11.8985 5.10393 11.3146 4.71893 10.7308C4.33382 10.147 4.0291 9.56841 3.80476 8.99497C3.58043 8.42141 3.46826 7.86752 3.46826 7.3333C3.46826 5.79486 3.96587 4.54936 4.9611 3.5968C5.95643 2.64425 7.13615 2.16797 8.50026 2.16797C9.86437 2.16797 11.0441 2.64425 12.0394 3.5968C13.0347 4.54936 13.5323 5.79486 13.5323 7.3333C13.5323 7.86752 13.4201 8.4203 13.1958 8.99164C12.9714 9.56308 12.6678 10.1417 12.2849 10.7276C11.9019 11.3135 11.4498 11.8975 10.9284 12.4795C10.4071 13.0616 9.84726 13.6282 9.24893 14.1795C9.14537 14.2735 9.02765 14.344 8.89576 14.391C8.76398 14.438 8.63215 14.4615 8.50026 14.4615Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLocation);
export default __webpack_public_path__ + "static/media/emptyLocation.a76d1150440df8ef5af7e28c0464bca3.svg";
export { ForwardRef as ReactComponent };